import React from 'react';
import about1Img from '../assets/about1.jpeg';
import '../styles/pages.css';

function About() {
  return (
    <div>
      <section className="hero">
        <div className="container">
          <h1>About Integritz Technologies</h1>
          <p>Fusion of Human Values and Technology</p>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <h2 className="section-title">Company Overview</h2>
          <div className="content-grid">
            <div>
              <img src={about1Img} alt="Company Overview" style={{width: '100%', borderRadius: '10px'}} />
            </div>
            <div className="content-text">
              <ul className="overview-list" style={{fontSize: '1.1rem'}}>
                <li>Integritz Technologies Private Limited is a Bangalore-based IT infrastructure solutions provider delivering comprehensive technology services to enterprises and organizations.</li>
                <li>We provide end-to-end cloud solutions, networking, security, and data center services, helping organizations build and manage robust IT infrastructure aligned with their business goals.</li>
                <li>Our expertise includes infrastructure deployment, storage management, and secure enterprise connectivity, supported by the supply of enterprise IT hardware such as laptops, desktops, and servers.</li>
                <li>We focus on delivering scalable, reliable, and secure technology environments that enhance operational efficiency and support business growth.</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="section" style={{background: 'var(--light)'}}>
        <div className="container">
          <h2 className="section-title">Mission & Vision</h2>
          <div className="mission-vision-grid">
            <div>
              <h3 style={{color: 'var(--primary)', marginBottom: '15px'}}>Our Mission</h3>
              <p>To empower businesses with reliable, secure, and scalable IT infrastructure solutions
                that drive growth and innovation while maintaining the highest standards of service and integrity.</p>
            </div>
            <div>
              <h3 style={{color: 'var(--secondary)', marginBottom: '15px'}}>Our Vision</h3>
              <p>To be the preferred IT infrastructure partner for enterprises, driven by innovation,
                operational excellence, and a strong commitment to aligning technology with human values.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <h2 className="section-title">Our Values</h2>
          <div className="content-text">
            <p className="centered-text" style={{fontSize: '1.1rem'}}>
              Customer-centric approach prioritizing partnership, transparency, and long-term success for every client engagement.
            </p>
          </div>
          <div className="why-choose-grid">
            <div className="why-card">
              <h3>Integrity</h3>
              <p>We conduct business with honesty and transparency</p>
            </div>
            <div className="why-card">
              <h3>Excellence</h3>
              <p>We strive for excellence in every solution we deliver</p>
            </div>
            <div className="why-card">
              <h3>Innovation</h3>
              <p>We embrace new technologies and innovative approaches</p>
            </div>
            <div className="why-card">
              <h3>Customer Focus</h3>
              <p>Your success is our priority and measure of achievement</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default About;
